module.exports = __webpack_public_path__ + "static/media/au.6ec4abe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/au.png
// module id = 1787
// module chunks = 0